import React, { useContext } from "react"
import { UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle } from "reactstrap"
import axios from "axios"
import * as Icon from "react-feather"
import API from '../../../providers/api'
import moment from 'moment'
import { history } from '../../../history'
import { UserContext } from './../../../context/context'
import { URL_IMG } from "../../../config"
import imgDefault from './../../../assets/img/logo/avatarDefault.png'
import { PURGE } from 'redux-persist';
import { useDispatch } from 'react-redux';

const UserDropdown = props => {
  const { activateAuth } = useContext(UserContext)
  const dispatch = useDispatch();
  return (
    <>
      <DropdownMenu >
        <DropdownItem onClick={() => {
          activateAuth(null)
          sessionStorage.clear();
          dispatch({
            type: PURGE,
            key: 'root', // Whatever you chose for the "key" value when initialising redux-persist in the **persistCombineReducers** method - e.g. "root"
            result: () => null // Func expected on the submitted action.
          });
        }}>
          <Icon.Power size={14} color={'#626262'} className="mr-50" />
          <span style={{ color: '#626262' }} className="align-middle">Logout</span>
        </DropdownItem>
      </DropdownMenu>
    </>
  )
}

class NavbarUser extends React.PureComponent {
  state = {
    navbarSearch: false,
    suggestions: [],
    notificationsCount: 0,
    notifications: [],
    notificationsRaw: null
  }

  // track hovered notification index for hover highlight
  hoveredNotifIndex = null
  user = (JSON.parse(sessionStorage.getItem('user')))

  componentDidMount() {
    axios.get("/api/main-search/data").then(({ data }) => {
      this.setState({ suggestions: data.searchResult })
    })
    // Initial fetch of notification count
    this.fetchNotifications();

    // Listen to navigation changes to refresh notifications
    try {
      this.unlisten = history.listen(() => {
        this.fetchNotifications();
      });
    } catch (e) {
      // if history is not available, ignore
      // eslint-disable-next-line no-console
      console.warn('History listener not attached', e);
    }
  }

  componentWillUnmount() {
    if (this.unlisten) {
      try { this.unlisten(); } catch (e) { /* noop */ }
    }
  }

  fetchNotifications = async () => {
    try {
      const resp = await API.getNumberRequests();
      if (!resp) return;
      // Try to parse JSON safely
      let json = null;
      try {
        json = await resp.json();
      } catch (e) {
        json = null;
      }
      // Expected shape (example): { message, requests: [...], success: true, summary: { total, pending, ... }, pending, total }
      let count = 0;
      let list = [];
      if (json) {
        // Debug log to help diagnose response shapes
        // eslint-disable-next-line no-console
        console.debug('Notifications response:', json);

        if (Array.isArray(json.requests)) {
          list = json.requests;
        } else if (Array.isArray(json.data)) {
          list = json.data;
        } else if (json.requests && typeof json.requests === 'object' && !Array.isArray(json.requests)) {
          // requests might be an object with numeric keys or id keys -> take values
          list = Object.values(json.requests).filter(v => v && typeof v === 'object');
        } else {
          // Handle numeric keys at top-level: { '0': {...}, '1': {...}, message: '...'}
          const numericValues = Object.keys(json)
            .filter(k => /^[0-9]+$/.test(k))
            .map(k => json[k])
            .filter(v => v && typeof v === 'object');
          if (numericValues.length) list = numericValues;
        }

        // Prefer pending from summary, then pending top-level, then total, then length of list
        if (json.summary && typeof json.summary.pending === 'number') count = json.summary.pending;
        else if (typeof json.pending === 'number') count = json.pending;
        else if (typeof json.total === 'number') count = json.total;
        else count = list.length;
      }

      this.setState({ notificationsCount: count, notifications: list, notificationsRaw: json });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn('Error fetching notifications', err);
    }
  }

  handleNavbarSearch = () => {
    this.setState({
      navbarSearch: !this.state.navbarSearch
    })
  }

  render() {
    return (
      <>
        <ul className="nav navbar-nav navbar-nav-user float-right">
          {/* Notifications dropdown */}
          <UncontrolledDropdown tag="li" className="nav-item me-3">
            <DropdownToggle tag="a" className="nav-link" style={{ cursor: 'pointer' }} onClick={this.fetchNotifications}>
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <Icon.Bell size={18} />
                {this.state.notificationsCount > 0 && (
                  <span style={{
                    position: 'absolute',
                    top: -6,
                    right: -10,
                    background: '#dc3545',
                    color: '#fff',
                    borderRadius: '50%',
                    padding: '5px 6px',
                    fontSize: 11
                  }}>{this.state.notificationsCount}</span>
                )}
              </div>
            </DropdownToggle>
            <DropdownMenu end style={{ minWidth: 320, maxHeight: 420, overflow: 'auto', padding: 0 }}>
              <div className="px-3 py-2 border-bottom small text-muted" style={{ background: '#fbfbfb' }}>
                <div style={{ fontWeight: 600, paddingTop: 8, paddingBottom: 8 }}>Notificaciones</div>
                {this.state.notificationsRaw && this.state.notificationsRaw.summary && (
                  <div className="small text-muted">Pendientes: {this.state.notificationsRaw.summary.pending} — Total: {this.state.notificationsRaw.summary.total}</div>
                )}
              </div>
              {Array.isArray(this.state.notifications) && this.state.notifications.length > 0 ? (
                this.state.notifications.map((n, i) => {
                  const isHovered = this.hoveredNotifIndex === i;
                  return (
                    <DropdownItem
                      key={`notif-${n.id || i}`}
                      onClick={() => { try { history.push(`/number-requests?filter=${encodeURIComponent(n.id)}`); } catch (e) { /* noop */ } }}
                      onMouseEnter={() => { this.hoveredNotifIndex = i; this.forceUpdate(); }}
                      onMouseLeave={() => { this.hoveredNotifIndex = null; this.forceUpdate(); }}
                      style={{
                        padding: '24px 26px',
                        marginBottom: 8,
                        borderRadius: 6,
                        background: isHovered ? '#f5f7fb' : 'transparent',
                        border: '1px solid transparent'
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-start" style={{ gap: 12, maxWidth: 300 }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 14, fontWeight: 600, paddingTop: 8, paddingBottom: 8, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{n.agent_name || `Solicitud ${i + 1}`}</div>
                          <div className="small text-muted mb-1" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', paddingTop: 8, paddingBottom: 8 }}>{n.reason || n.project || ''}</div>
                          <div className="small text-muted mt-1">Cantidad: {n.count ?? '-'}</div>
                        </div>
                        <div style={{ marginLeft: 12, textAlign: 'right', minWidth: 100 }}>
                          <div className="small text-muted" style={{ marginBottom: 6 }}>{n.created_at ? moment(n.created_at).format('DD/MM/YYYY hh:mm A') : ''}</div>
                          {!n.admin_read && (
                            <div><span className="badge bg-danger">Nuevo</span></div>
                          )}
                        </div>
                      </div>
                    </DropdownItem>
                  );
                })
              ) : (
                <div className="p-3 small text-muted">No hay notificaciones</div>
              )}
            </DropdownMenu>
          </UncontrolledDropdown>

          {/* User dropdown */}
          <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
            <DropdownToggle tag="a" className="nav-link dropdown-user-link">
              <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <div className="user-nav d-sm-flex d-none" style={{ marginRight: 8 }}>
                <span className="user-name text-bold-600" style={{ marginRight: 8 }}>
                  {`${this.user.name}`}
                </span>
                <span className="user-status">
                  {
                    this.user.profile === 1 ? 'Master' :
                      this.user.profile === 2 ? 'Administrator' :
                        this.user.profile === 104 ? 'Supervisor' :
                          this.user.profile === 106 ? 'Support' :
                            this.user.profile === 118 ? 'Agent' :
                              this.user.profile === 211 ? 'Processor' :
                                this.user.profile === 219 ? 'Customer Leader' :
                                  this.user.profile === 227 ? 'Customer Service' :
                                    this.user.profile === 228 ? 'Supplementary Processor' :
                                      this.user.profile === 238 ? 'Quality Leader' :
                                        this.user.profile === 239 ? 'Quality Aux' :
                                          this.user.profile === 251 ? 'Administrator TOP' :
                                            this.user.profile === 255 ? 'Auditor' :
                                              this.user.profile === 256 ? 'Processor.' :
                                    ''
                  }
                </span>
              </div>
              </div>
              <span data-tour="user">
                <img
                  src={this.user.photo ? `${URL_IMG}/${this.user.photo}` : imgDefault}
                  className="round"
                  height="40"
                  width="40"
                  alt="avatar"
                />
              </span>
            </DropdownToggle>
            <UserDropdown {...this.props} />
          </UncontrolledDropdown>
        </ul>
      </>
    )
  }
}
export default NavbarUser
